export default __webpack_public_path__ + "static/media/BlackIos.db7402b7.svg";